import BigNumber from 'bignumber.js'

interface LineDataItem {
  x: number
  y: number
}

interface LineData {
  data: LineDataItem[]
  yMinDada: number
  yMaxDada: number
  xMinDada: number
}

export const getLineData = (dataSource: number[][], baseLine = 0): LineData => {
  const yData: number[] = []
  const xData: number[] = []
  const data: LineDataItem[] =
    dataSource?.map((item, index) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [_, y] = item
      const _y = BigNumber(y).minus(BigNumber(baseLine)).toNumber()
      yData.push(_y)
      xData.push(index)
      return {
        x: index,
        y: _y,
      }
    }) || []

  const yMinDada: number = Math.min(...yData)
  const yMaxDada: number = Math.max(...yData)
  const xMinDada: number = Math.min(...xData)

  return { data, yMinDada, yMaxDada, xMinDada }
}
